<template>
    <div>
        <v-card elevation="0">
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#189AB4" dark v-if="!viewmode" @click="viewmode = true">View Custom Entries</v-btn>
                <v-btn color="#189AB4" dark v-else @click="viewmode = false">Add New Entry</v-btn>
            </v-card-actions>
            <v-card-text>
                <v-card elevation="0" v-if="!viewmode">
                    <v-card-text>
                        <v-form ref="form">
                        <v-row class="ma-0 pa-1" dense>
                            <v-col cols="12" md="2" class="ma-0 pa-1"><v-text-field dense outlined v-model="strm" label="Strm" :rules="[v=> /^\d{4}$/.test(v) || '4-digit number only']" @keypress="validate()"></v-text-field></v-col>
                            <v-col cols="12" md="4" class="ma-0 pa-1"><v-select dense outlined v-model="subject" :items="disciplineitems" label="Discipline" :rules="[value => !!value || 'Required']" @change="validate()" item-text="label" item-value="value"></v-select></v-col>
                            <v-col cols="12" md="2" class="ma-0 pa-1"><v-text-field dense outlined v-model="location" label="Location" :rules="[value => !!value || 'Required']" @keypress="validate()"></v-text-field></v-col>
                            <v-col cols="12" md="2" class="ma-0 pa-1"><v-text-field dense outlined v-model="acadgroup" label="Group" :rules="[value => !!value || 'Required']" @keypress="validate()"></v-text-field></v-col>
                            <v-col cols="12" md="2" class="ma-0 pa-1"><v-select dense outlined v-model="ssrcomponent" :items="ssritems" label="SSR Comp." :rules="[value => !!value || 'Required']" @change="validate()"></v-select></v-col>
                            <v-col cols="12" md="3" class="ma-0 pa-1"><v-text-field dense outlined v-model="classsection" label="Class Section" :rules="[value => !!value || 'Required']" @keypress="validate()"></v-text-field></v-col>
                            <v-col cols="12" md="2" class="ma-0 pa-1"><v-text-field dense outlined v-model="classnbr" label="Class Number" :rules="[value => !!value || 'Required']" @keypress="validate()"></v-text-field></v-col>
                            <v-col cols="12" md="2" class="ma-0 pa-1"><v-text-field dense outlined v-model="catalognbr" label="Catalog Number" :rules="[value => !!value || 'Required']" @keypress="validate()"></v-text-field></v-col>
                            <v-col cols="12" md="2" class="ma-0 pa-1"><v-text-field dense outlined v-model="enrlcap" label="Enrolment Capacity" :rules="[v=> /^\d+$/.test(v) || 'number only']" @keypress="validate()"></v-text-field></v-col>
                            <v-col cols="12" md="3" class="ma-0 pa-1"><v-text-field dense outlined v-model="facilityid" label="Facility ID" :rules="[value => !!value || 'Required']" @keypress="validate()"></v-text-field></v-col>
                            <v-col cols="12" md="6" class="ma-0 pa-1"><v-text-field dense outlined v-model="instructorname" label="Instructor Name" @keypress="validate()"></v-text-field></v-col>
                            <v-col cols="12" md="2" class="ma-0 pa-1"><v-text-field dense outlined v-model="campus" label="Campus" :rules="[value => !!value || 'Required']" @keypress="validate()"></v-text-field></v-col>
                            <v-col cols="12" md="2" class="ma-0 pa-1"><v-text-field dense outlined v-model="associatedclass" label="Assoc. Class" :rules="[value => !!value || 'Required']" @keypress="validate()"></v-text-field></v-col>
                            <v-col cols="12" md="2" class="ma-0 pa-1"><v-text-field dense outlined v-model="sessioncode" label="Session Code" :rules="[value => !!value || 'Required']" @keypress="validate()"></v-text-field></v-col>
                            <v-col cols="12" md="12" class="ma-0 pa-1"><v-text-field dense outlined v-model="descr" label="Description (title)" :rules="[value => !!value || 'Required']" @keypress="validate()"></v-text-field></v-col>
                            <v-col cols="12" md="12" class="ma-0 pa-1"><v-textarea height="100" outlined v-model="descrlong" label="Description (detail)" :rules="[value => !!value || 'Required']" @keypress="validate()"></v-textarea></v-col>
                            <v-col cols="12" md="6" class="ma-0 pa-1"><v-text-field dense outlined v-model="meetingtimestart" label="Meeting Time (start)" :rules="[v=> /^[0-9]{2}:[0-9]{2}$/.test(v) || 'Invalid Format (HH:MM in 24-hour format)']" @keypress="validate()"></v-text-field></v-col>
                            <v-col cols="12" md="6" class="ma-0 pa-1"><v-text-field dense outlined v-model="meetingtimeend" label="Meeting Time (end)" :rules="[v=> /^[0-9]{2}:[0-9]{2}$/.test(v) || 'Invalid Format (HH:MM in 24-hour format)']" @keypress="validate()"></v-text-field></v-col>
                            <v-col cols="12" md="6" class="ma-0 pa-1">
                                <v-simple-table style="width: 100%; border-collapse: collapse;" dense>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th>Mon</th>
                                                <th>Tue</th>
                                                <th>Wed</th>
                                                <th>Thu</th>
                                                <th>Fri</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td><v-checkbox v-model="mon" value="Mon" @change="validate()" false-value=""></v-checkbox></td>
                                                <td><v-checkbox v-model="tues" value="Tue" @change="validate()" false-value=""></v-checkbox></td>
                                                <td><v-checkbox v-model="wed" value="Wed" @change="validate()" false-value=""></v-checkbox></td>
                                                <td><v-checkbox v-model="thurs" value="Thu" @change="validate()" false-value=""></v-checkbox></td>
                                                <td><v-checkbox v-model="fri" value="Fri" @change="validate()" false-value=""></v-checkbox></td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                            <v-col cols="12" md="6" class="ma-0 pa-1 d-flex justify-end align-end" style="text-align: right;">
                                <v-btn color="#68BBE3" @click="addTimetableEntry" :disabled="addbtndisabled" large :loading="addbtnloading" small>Add to Timetable</v-btn>
                            </v-col>
                        </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
                <v-card elevation="0" v-else>
                    <v-card-text>
                        <ManageEntries />
                    </v-card-text>
                </v-card>
            </v-card-text>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import ManageEntries from "./ManageCustomTimetable.vue"
export default {
    components: {
        ManageEntries
    },
    data(){
        return {
            host: location.hostname.toString(),
            viewmode: false,
            strm: "",
            classsection: "",
            subject: "",
            catalognbr: "",
            classnbr: "",
            location: "KC",
            enrlcap: "",
            instructorname: "",
            meetingtimestart: "00:00",
            meetingtimeend: "00:00",
            acadgroup: "KC",
            mon: "",
            tues: "",
            wed: "",
            thurs: "",
            fri: "",
            facilityid: "",
            descrlong: "",
            associatedclass: "",
            ssrcomponent: "",
            campus: "KINGS",
            descr: "",
            sessioncode: "",
            disciplineitems: [],
            ssritems: ['LEC', 'TUT', 'LAB'],
            addbtndisabled: true,
            addbtnloading: false,
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
        }
    },
    methods: {
        getSubjectList(){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getsubjects';
            that.disciplineitems = [];

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        if(json.data.length > 0){
                            json.data.forEach(element => {
                                that.disciplineitems.push({"label" : element["label"]+'('+element["value"]+')', "value": element["value"]});
                            });
                        }
                    }else {
                        that.setSnackbar("Warning: "+json.message, "#EF6C00"); //orange
                    }
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
        },
        validate(){
            const that = this;

            var strm = /^\d{4}$/.test(that.strm);
            var classsection = that.classsection.length;
            var catalognbr = that.catalognbr.length;
            var classnbr = that.classnbr.length;
            var location = that.location.length;
            var enrlcap = /^\d+$/.test(that.enrlcap);
            var meetingtimestart = /^[0-9]{2}:[0-9]{2}$/.test(that.meetingtimestart);
            var meetingtimeend = /^[0-9]{2}:[0-9]{2}$/.test(that.meetingtimeend);
            var acadgroup = that.acadgroup.length;
            var facilityid = that.facilityid.length;
            var descrlong = that.descrlong.length;
            var descr = that.descr.length;
            var associatedclass = that.associatedclass.length;
            var campus = that.campus.length;
            var sessioncode = that.sessioncode.length;

            if(
                strm && classsection>0 && catalognbr>0 && classnbr>0 && location>0 && enrlcap && meetingtimestart && meetingtimeend && acadgroup>0 &&
                facilityid>0 && descr>0 && descrlong>0 && associatedclass>0 && campus>0 && sessioncode>0 &&
                (that.mon == "Mon" || that.tues == "Tue" || that.wed == "Wed" || that.thurs == "Thu"|| that.fri == "Fri")
            ){
                if(that.instructorname == null){
                    that.instructorname = ""
                }

                that.addbtndisabled = false;
            }else {
                that.addbtndisabled = true;
            }
        },
        addTimetableEntry(){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';
            that.addbtnloading = true;

            let record = {
                strm: that.strm,
                classsection: that.classsection,
                subject: that.subject,
                catalognbr: that.catalognbr,
                classnbr: that.classnbr,
                location: that.location,
                enrlcap: that.enrlcap,
                instructorname: that.instructorname,
                meetingtimestart: "1/1/1900 "+that.meetingtimestart,
                meetingtimeend: "1/1/1900 "+that.meetingtimeend,
                acadgroup: that.acadgroup,
                mon: that.mon,
                tues: that.tues,
                wed: that.wed,
                thurs: that.thurs,
                fri: that.fri,
                facilityid: that.facilityid,
                descrlong: that.descrlong,
                descr: that.descr,
                associatedclass: that.associatedclass,
                ssrcomponent: that.ssrcomponent,
                campus: that.campus,
                sessioncode: that.sessioncode
            }

            const formData = new FormData();
            formData.append("mode", "setcustom");
            formData.append("data", JSON.stringify(record));

            fetch(api, {
                method: 'POST',
                body: formData
            })
            .then(function(response){
                return response.json();
            })
            .then(function (data) {
                if(data.result.match(/ok/i)){
                    that.setSnackbar("Successful: "+data.message.toString(), "green");
                    that.$refs.form.reset();
                }else {
                    that.setSnackbar("Warning: "+data.message.toString(), "orange");
                }

                that.addbtnloading = false;
            })
            .catch(function (err) {
                that.setSnackbar("Error occurred : "+err.toString(), "red");
                that.addbtnloading = false;
            })
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    created(){
        const that = this;
        that.getSubjectList();
    }
}
</script>